import { renderOrganizations } from '../organizations/index.js';

/**
 * Organizations inside Settings (super-admin). Embeds the real screen in set-main.
 * @param {{ host: HTMLElement, me: object, productId?: string }} opts
 */
export function mountOrganizations(opts) {
  const node = renderOrganizations({
    me: opts.me,
    productId: opts.productId,
  });
  opts.host.append(node);
  return {
    dispose() {
      node.dispatchEvent(new CustomEvent('bonnie:unmount'));
    },
  };
}
